const handleDeleteQuestionModalEquipService = {
  confirm: 'Do you really want to delete the question',
  title: 'DELETE CHECKLIST QUESTION'
};

export default handleDeleteQuestionModalEquipService;
